import ajax from '@/plugin/ajax'
import utils from '@/common/utils'

/**
 * 获取列表页信息
 */

export const getMailList = function (data) {
    return ajax({
        method: 'get',
        url: '/vipapi/getList',
        params: data
        //  {
        //     folderId:folderId,
        //     offset:offset,
        //     limit:limit,
        //     order: 'id',
        //     sort: '0/1'
        // }
    }).then(function (response) {
        return response
    }).catch(function (error) {
        console.log(error)
    })
}
export const markRead = function (data) {
    return ajax({
        method: 'POST',
        url: '/vipapi/markRead',
        data: utils.mailParam(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        //  {
        //      ids:[1,2,3]
        //      read:0/1 //1已读-0未读
        // }
    })
}

export const markStar = function (data) {
    return ajax({
        method: 'POST',
        url: '/vipapi/markStar',
        data: utils.mailParam(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        //  {
        //      ids:[1,2,3]
        //      star:0/1 //1已读-0未读
        // }
    })
}

export const moveFolder = function (data) {
    return ajax({
        method: 'POST',
        url: '/vipapi/moveFolder',
        data: utils.mailParam(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        //  {
        //      ids:[1,2]  移动的邮件ID数组
        // form:111 移动邮件的源文件夹
        // to:1234  移动邮件的目标文件夹

        // 搜索页面删除from传 -10
        // }
    })
}

export const delMail = function (data) {
    return ajax({
        method: 'DELETE',
        url: '/vipapi/del',
        data: utils.mailParam(data),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
        }
        //  {
        // ids:[1,2]
        // folderId:1,
        // spamType: //举报类型
        // // 0不举报 1广告邮件，2 钓鱼欺诈，3违法反动，4其他邮件
        // 搜索页面删除传 -10
        // }
    })
}

export const recvNewMail = function (email) {
    return ajax({
        method: 'GET',
        url: 'vipapi/pop_end/pop',
        params: {
            userid: email,
            priority: 1,
            t: +new Date()
        }
    }).then(function (response) {
        return response
    }).catch(function (error) {
        console.log(error)
    })
}
export const search = function (data) {
    return ajax({
        method: 'get',
        url: '/vipapi/search',
        params: data
    })
}



// WEBPACK FOOTER //
// ./src/service/mailListService.js